/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-04 08:27:48
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import './organizationConfig.less';
import { createNamespace, createBEM } from 'src/util/bem';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import OrganizationConfigApi, { OrganizationConfigDOI } from './api/organizationConfigApi';
import { CommonUtil } from 'src/util/commonUtil';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import CellOperate from 'src/components/agGridComponent/cellOperate';
import { Toast } from 'src/util/toast';
import Button from 'src/types/iview/Button';
import EnumOperates from 'src/enums/enumOperates';
import alertOrganizationOperateModal from './organizationOperateModal';
import alertAddStationModal from './addStationModal';
let bem = createBEM('organization-config');

@Component({ name: 'organization-config' })
export default class OrganizationConfig extends Vue.Component<any> {
    data: any = [];

    currentOrgainzation!: OrganizationConfigDOI.OrganizationI;
    // 附件相关的表格
    gridOptions: GridOptions = {};

    columnDefs: ColDefCustom[] = [];
    rowData: OrganizationConfigDOI.RowDataI[] = [];

    async queryAll() {
        let { code, data } = await OrganizationConfigApi.searchAllOrganization();
        if (code === 0) {
            CommonUtil.treeForEach(
                data,
                (i: any) => {
                    i.title = i.name;
                    i.children = i.children_list;
                    i.expand = true;
                    if(this.currentOrgainzation && this.currentOrgainzation.id === i.id) {
                        i.selected = true
                    }
                },
                'children_list',
            );
            if (data[0]) {
                this.data = data;
            }
        }
    }
    async selectChange(i) {
        this.currentOrgainzation = i[0];
        this.queryById();
    }
    async queryById() {
        let { code, data } = await OrganizationConfigApi.searchSubordinate(this.currentOrgainzation.id);
        if (code === 0) {
            this.rowData = data;
        }
    }
    async add() {
        let res = await alertOrganizationOperateModal(EnumOperates.Add.getName(), this.currentOrgainzation);
        if (res) {
            this.queryById();
            this.queryAll()
        }
    }
    async mounted() {
        await this.queryAll();
        // @ts-ignore
        this.data[0].selected = true;
        this.currentOrgainzation = this.data[0];
        this.selectChange([this.data[0]]);
        this.data = JSON.parse(JSON.stringify(this.data))
    }
    created() {
        let t = this
        this.columnDefs = [
            {
                headerName: '组织名称',
                field: 'name',
                minWidth: 140,
            },
            {
                headerName: '负责人',
                field: 'principal',
                minWidth: 140,
            },
            {
                headerName: '联系电话',
                field: 'phone',
                minWidth: 140,
            },
            {
                headerName: '备注',
                field: 'remark',
                minWidth: 140,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 160,
                maxWidth: 160,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '选择站点',
                        async click(params) {
                            let data: OrganizationConfigDOI.RowDataI = params.data;
                            alertAddStationModal(data.id, data.parent_id,  t.$route.path === '/platform/systemConfig/organizationConfig/index');
                        },
                    },
                    {
                        text: '修改',
                        click: async params => {
                            let data: OrganizationConfigDOI.RowDataI = params.data;
                            let res = await alertOrganizationOperateModal(EnumOperates.Update.getName(), this.currentOrgainzation, data);
                            if (res) {
                                this.queryById();
                                this.queryAll()
                            }
                        },
                    },
                    {
                        text: '删除',
                        click: async params => {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: OrganizationConfigDOI.RowDataI = params.data;
                            let { code } = await OrganizationConfigApi.delete(data.id);
                            if (code === 0) {
                                this.queryById();
                                this.queryAll()
                            }
                        },
                    },
                ],
            },
        ];
    }
    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg style="height: 100%">
                        <div class={bem('left-menu')}>
                            <div class={bem('left-menu-title')}>站点列表</div>
                            <div class={bem('left-menu-tree')}>
                                <tree ref="tree" class={bem()} data={this.data} on-on-select-change={this.selectChange.bind(this)} />
                            </div>
                        </div>
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div class={bem('right-menu')}>
                        <div class={bem('right-menu-title')}>
                            下级组织
                            <Button type="primary" on-click={this.add.bind(this)}>
                                新增
                            </Button>
                        </div>
                        <AgGridVueCustomTsx
                            class={bem('right-menu-tb')}
                            gridOptions={this.gridOptions}
                            columnDefs={this.columnDefs}
                            rowData={this.rowData}
                            enableServerSideSorting={false}
                            checkBoxShow={false}
                            pageShow={false}
                        />
                    </div>
                </i-content>
            </layout>
        );
    }
}
